// extracted by mini-css-extract-plugin
module.exports = {"Text":"Text_Text__1deRx","File":"Text_File__hXM3U","fadeIn":"Text_fadeIn__3jl7j","modalFadeIn":"Text_modalFadeIn__D2hXF","slideInFromRight":"Text_slideInFromRight__s-qUs"};